import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { NgIf } from '@angular/common';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';

/**
 * Shared text-entry popup for the Create Item modal (Restrictions / Special
 * Notes). One component, parameterized by title: autofocused textarea,
 * character counter, Clear / Done. Modeled on item-restriction.component so
 * both fields behave identically.
 *
 * Contract semantics: an empty (or whitespace-only) result means the field is
 * unset — the request member is omitted (rule 5 is satisfied by construction,
 * there is no "present but empty" state).
 */
@Component({
  selector: 'app-item-text-modal',
  templateUrl: './item-text-modal.component.html',
  styleUrls: ['./item-text-modal.component.scss'],
  standalone: true,
  imports: [NgIf, FormsModule, ReactiveFormsModule]
})
export class ItemTextModalComponent implements OnInit, AfterViewInit {
  @Input() title = '';
  @Input() value = '';
  @Input() placeholder = '';
  @Input() maxLength = 1024;
  @Output() saved = new EventEmitter<string>();
  @Output() closedModal = new EventEmitter<void>();
  @ViewChild('textArea') textArea: ElementRef<HTMLTextAreaElement>;

  text: FormControl;

  ngOnInit(): void {
    this.text = new FormControl(this.value || '');
  }

  ngAfterViewInit(): void {
    this.textArea.nativeElement.focus();
  }

  get length(): number {
    return (this.text.value || '').length;
  }

  get isEmpty(): boolean {
    const value = this.text.value;
    return !value || !value.trim();
  }

  /** Discard changes and close. */
  cancel(): void {
    this.closedModal.emit();
  }

  /** Empty the field and close — the member will be omitted from the request. */
  clear(): void {
    this.saved.emit('');
  }

  /** Save the trimmed text; whitespace-only saves as empty (= unset). */
  done(): void {
    this.saved.emit(this.isEmpty ? '' : this.text.value.trim());
  }
}
